import React, { useState, useEffect, useRef } from 'react';
import {
  AudioOutlined,
  LoadingOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { Spin, message, Button } from 'antd';
import { request } from 'umi';
import styles from './styles.less';
// Function to check if an IP is a local IP (for ICE candidate filtering)
function isLocalIP(ip) {
  if (
    /^10\./.test(ip) ||
    /^192\.168\./.test(ip) ||
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(ip) ||
    /^127\./.test(ip) ||
    /^169\.254\./.test(ip)
  ) {
    return true;
  }
  if (ip.length > 15) {
    return true;
  }
  return false;
}

const WebRTCComponent = (props) => {
  const { serialNumber, timestamp, clientCode, sign, apiPrefix, deviceId } =
    props;
  const [playUrlInput, setPlayUrlInput] = useState('');
  const [talkUrlInput, setTalkUrlInput] = useState('');
  const [localSDP, setLocalSDP] = useState(null);
  const [candidateSDP, setCandidateSDP] = useState('');
  const [hasLocalIP, setHasLocalIP] = useState(false);
  const [iceCandidateCount, setIceCandidateCount] = useState(0);
  const [iceCandidateCountOK, setIceCandidateCountOK] = useState(0);
  const [callButtonDisabled, setCallButtonDisabled] = useState(false);
  const [hangupButtonDisabled, setHangupButtonDisabled] = useState(true);
  const [startTalkButtonDisabled, setStartTalkButtonDisabled] = useState(false);
  const [stopTalkButtonDisabled, setStopTalkButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const remoteVideoRef = useRef(null); // For video element
  const remoteAudioRef = useRef(null); // For audio element
  const pcTalk = useRef(null);
  // const pc = useRef(
  //   new RTCPeerConnection({
  //     iceServers: [{ urls: ['stun:stun.voipbuster.com:3478'] }],
  //   }),
  // ).current;

  // const pcTalk = useRef(
  //   new RTCPeerConnection({
  //     iceServers: [{ urls: ['stun:stun.voipbuster.com:3478'] }],
  //   }),
  // ).current;
  const tempObj = {};
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  } else if (deviceId) {
    tempObj.deviceId = deviceId;
  }
  const getJFTalkBackUrl = () => {
    if (!tempObj.deviceId && !tempObj.serialNumber) {
      return message.error('参数缺失');
    }
    return request(`${apiPrefix}/openapi/video/getJFTalkBackUrl`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: {
        ...tempObj,
        mediaType: 'webrtc',
      },
    });
  };
  useEffect(() => {
    if (talkUrlInput && talkUrlInput !== '') {
      initWebRtc();
    }
  }, [talkUrlInput]);

  useEffect(() => {
    if (iceCandidateCountOK === 0) return;
    let tmpLocalSDP = localSDP;
    if (iceCandidateCountOK === 1) {
      // console.log('localSDP1', tmpLocalSDP);
      if (localSDP) {
        let searchStringAudio = 'm=audio';
        let indexAudio = localSDP.indexOf(searchStringAudio);
        let searchStringVideo = 'm=video';
        let indexVideo = localSDP.indexOf(searchStringVideo);
        let indexPos = 0;
        if (indexVideo > indexAudio) {
          indexPos = indexVideo;
        } else {
          indexPos = indexAudio;
        }
        tmpLocalSDP =
          localSDP.substring(0, indexPos) +
          candidateSDP +
          localSDP.substring(indexPos);
        setLocalSDP(tmpLocalSDP);
        // console.log('localSDP2', tmpLocalSDP);
      }
      //candidateSDP=null;
    }
    if (iceCandidateCountOK >= 2) {
      // console.log('ICE negotiation finished');
      let searchString = 'a=ice-options:trickle';
      if (localSDP) {
        setLocalSDP(
          (prevLocalSDP) =>
            prevLocalSDP.replace(searchString, '') + candidateSDP,
        );
        tmpLocalSDP = localSDP.replace(searchString, '') + candidateSDP;
      }
      // console.log('localSDP3', tmpLocalSDP);
      doCall(tmpLocalSDP, talkUrlInput);
      setCandidateSDP('');
      setIceCandidateCountOK(0);
      setIceCandidateCount(0);
    }
  }, [iceCandidateCountOK]);

  const initWebRtc = () => {
    // console.log('initWebRtc', talkUrlInput);
    // pc.onicecandidate = (event) => handleCandidate(event, playUrlInput);
    // pc.ontrack = (event) => handleTrack(event, remoteVideoRef.current);
    // pc.onconnectionstatechange = (event) =>
    //   console.log('Connection state:', event.currentTarget.connectionState);

    pcTalk.current.onicecandidate = (event) =>
      handleCandidate(event, talkUrlInput);
    pcTalk.current.ontrack = (event) =>
      handleTrack(event, remoteAudioRef.current);
    pcTalk.current.onconnectionstatechange = (event) =>
      console.log(
        'Talk connection state:',
        event.currentTarget.connectionState,
      );
  };

  // console.log('iceCandidateCountOK', iceCandidateCountOK);
  const handleCandidate = (event, url) => {
    console.log('handleCandidate', event, url);
    if (event.candidate) {
      setIceCandidateCount(iceCandidateCount + 1);
      const candidateIP = event.candidate.candidate.split(' ')[4];
      setHasLocalIP(isLocalIP(candidateIP));

      if (!hasLocalIP) {
        setCandidateSDP(
          (prevCandidateSDP) =>
            prevCandidateSDP + 'a=' + event.candidate.candidate + '\r\n',
        );
        setIceCandidateCountOK(
          (iceCandidateCountOK) => iceCandidateCountOK + 1,
        );
        //console.log("iceCandidateCountOK",iceCandidateCountOK);
      }
    }
  };
  useEffect(() => {
    return () => {
      setTalkDisable();
    };
  }, []);
  const handleTrack = (event, videoElement) => {
    // console.log('handleTrack', event, videoElement);
    if (event.track.kind === 'audio') {
      // console.log('Received audio track');
    } else if (event.track.kind === 'video') {
      // console.log('Received video track');
    }

    const stream = event.streams[0];
    if (stream) {
      videoElement.srcObject = stream;
    }
  };

  // const call = () => {
  //   setCallButtonDisabled(true);
  //   const videoTransceiverInit = { direction: 'sendrecv', sendEncodings: [] };
  //   const audioTransceiverInit = { direction: 'sendrecv' };

  //   pc.addTransceiver('video', videoTransceiverInit);
  //   pc.addTransceiver('audio', audioTransceiverInit);

  //   pc.createOffer()
  //     .then((desc) => {
  //       pc.setLocalDescription(desc).then(() => {
  //         setLocalSDP(desc.sdp);
  //       });
  //     })
  //     .catch(console.error);
  // };

  const doCall = (param, url) => {
    if (url === talkUrlInput) {
      negotiateTalkSDP(param, url);
    } else {
      negotiateSDP(param, url);
    }
  };

  const negotiateSDP = (param, url) => {
    const json = { action: 'offer', sdp: param };
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 304)) {
        const jsonResponse = JSON.parse(xhr.responseText);
        const answer = { sdp: jsonResponse.sdp, type: 'answer' };
        // pc.setRemoteDescription(answer)
        //   .then(() => {
        //     console.log('SDP negotiation complete');
        //   })
        //   .catch(console.error);
      }
    };
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    xhr.send(JSON.stringify(json));
  };

  const negotiateTalkSDP = (param, url) => {
    const json = { action: 'offer', sdp: param };
    let xhrTalk = new XMLHttpRequest();
    xhrTalk.onreadystatechange = () => {
      if (
        xhrTalk.readyState === 4 &&
        (xhrTalk.status === 200 || xhrTalk.status === 304)
      ) {
        const jsonResponse = JSON.parse(xhrTalk.responseText);
        const answer = { sdp: jsonResponse.sdp, type: 'answer' };
        pcTalk.current
          .setRemoteDescription(answer)
          .then(() => {
            console.log('Talk SDP negotiation complete');
          })
          .catch(console.error);
      }
    };
    xhrTalk.open('POST', url, true);
    xhrTalk.setRequestHeader('Content-type', 'application/json; charset=utf-8');
    xhrTalk.send(JSON.stringify(json));
  };

  const setTalkEnable = () => {
    // 重新初始化 pcTalk 连接
    pcTalk.current = new RTCPeerConnection({
      iceServers: [{ urls: ['stun:stun.voipbuster.com:3478'] }],
    });
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        console.log('getUserMedia audio'); //const userMedia = navigator.mediaDevices.getUserMedia({ audio: true });
        pcTalk.current.addTransceiver('video', { direction: 'sendrecv' }); //sendrecv
        pcTalk.current.addTransceiver(stream.getTracks()[0], {
          direction: 'sendrecv',
        });
        setTalkLocalOffer();
      })
      .catch(console.error);
  };

  const setTalkLocalOffer = () => {
    pcTalk.current
      .createOffer()
      .then((desc) => {
        pcTalk.current.setLocalDescription(desc).then(() => {
          setLocalSDP(desc.sdp);
        });
      })
      .catch(console.error);
    setTimeout(() => {
      setStopTalkButtonDisabled(false);
      setStartTalkButtonDisabled(true);
    }, 3000);
  };

  const setTalkDisable = () => {
    if (!pcTalk.current) return;
    // 停止音频流
    pcTalk?.current?.getSenders().forEach((sender) => {
      if (sender.track) {
        // 检查 sender.track 是否存在
        sender.track.stop(); // 停止音频轨道
      }
    });

    // 关闭 pcTalk 连接
    pcTalk.current.close();

    // 禁用“开始喊话”和“停止喊话”按钮
    pcTalk.current = null;
    setTimeout(() => {
      setStartTalkButtonDisabled(false);
      setStopTalkButtonDisabled(false);
    }, 3000);
    // console.log('Talk ended');
  };

  // const hangup = () => {
  //   console.log('Ending call');
  //   pc.close();
  //   setHangupButtonDisabled(true);
  //   setCallButtonDisabled(false);
  // };

  return (
    <>
      <div className={styles.actionBox}>
        {!startTalkButtonDisabled ? (
          <Button
            disabled={loading}
            onClick={() => {
              setLoading(true);
              getJFTalkBackUrl()
                .then((res) => {
                  setTalkUrlInput(res.data);
                  setTalkEnable();
                  setTimeout(() => {
                    setLoading(false);
                  }, 3000);
                })
                .catch(() => {
                  setLoading(false);
                });
            }}
            icon={
              loading ? (
                <Spin size="small" indicator={<LoadingOutlined />} />
              ) : (
                <AudioOutlined />
              )
            }
            type="link"
          >
            开始喊话
          </Button>
        ) : (
          <Button
            disabled={loading}
            onClick={() => {
              setLoading(true);
              setTalkDisable();
              setTimeout(() => {
                setLoading(false);
              }, 3000);
            }}
            icon={
              loading ? (
                <Spin size="small" indicator={<LoadingOutlined />} />
              ) : (
                <CloseOutlined />
              )
            }
            type="link"
          >
            结束喊话
          </Button>
        )}
      </div>

      <div style={{ display: 'none' }}>
        <video ref={remoteVideoRef} autoPlay></video>
        <audio ref={remoteAudioRef} autoPlay></audio>
      </div>
    </>
  );
};

export default WebRTCComponent;
